module.exports = __webpack_public_path__ + "static/media/adelphi-logo.d1c62898.svg";